import { DocumentStatusSchema } from '@rock/types';
import { useSearchParams } from 'react-router-dom';
import { useSetSearchParam } from '@/lib/searchParams';
import type { SpaceFilter, StatusFilter } from './documentStatus';

const DEFAULT_STATUS: StatusFilter = 'approved';

/**
 * The status + space filters shared by the catalog list pages, backed by URL search params
 * (`?status=draft&space=hvac`) so they survive refresh and the row-click → details → back round trip.
 * The defaults (approved, all spaces) are omitted from the URL.
 */
export function useDocumentListFilters(): {
    statusFilter: StatusFilter;
    spaceFilter: SpaceFilter;
    setStatusFilter: (status: StatusFilter) => void;
    setSpaceFilter: (space: SpaceFilter) => void;
} {
    const [searchParams] = useSearchParams();
    const setSearchParam = useSetSearchParam();
    const statusParam = searchParams.get('status');
    const statusFilter: StatusFilter =
        statusParam === 'all'
            ? 'all'
            : (DocumentStatusSchema.options.find((status) => status === statusParam) ?? DEFAULT_STATUS);
    const spaceFilter = (searchParams.get('space') ?? 'all') as SpaceFilter;
    return {
        statusFilter,
        spaceFilter,
        setStatusFilter: (status) => setSearchParam('status', status === DEFAULT_STATUS ? undefined : status),
        setSpaceFilter: (space) => setSearchParam('space', space === 'all' ? undefined : space),
    };
}
